<template>
    <el-drawer
        :title="title"
        :visible.sync="show"
        direction="btt"
        :before-close="handleClose"
        :destroy-on-close="true"
        :size="this.$tools.mainHeight() + 'px'"
    >
        <div class="info-tab-outer">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="资金记录" name="bill">
                    <el-table
                        :data="records"
                        stripe
                        style="width: 100%"
                        :height="this.$tools.mainHeight() - 135"
                        class="alibaba-order-table"
                    >
                        <el-table-column prop="bizDate" label="交易时间" width="160">
                            <template slot-scope="order">{{ $tools.timestampToTime(order.row.bizDate)}}</template>
                        </el-table-column>
                        
                        <el-table-column prop="account" label="交易账户" width="120"></el-table-column>
                        <el-table-column prop="type" label="交易类型" width="100"></el-table-column>


                        <el-table-column prop="amount" label="金额($)" width="150">
                            <template slot-scope="order">{{ $tools.parsecost(order.row.amount, true)}}</template>
                        </el-table-column>
                    </el-table>

                    <el-pagination
                        small
                        layout="total, prev, pager, next"
                        :total="params.total"
                        @current-change="pageBill"
                    ></el-pagination>
                </el-tab-pane>
                <el-tab-pane label="生产记录" name="product">敬请期待</el-tab-pane>
            </el-tabs>
        </div>
    </el-drawer>
</template>


<script>
export default {
    props: {
        show: { type: Boolean, default: false },
        isRoot: { type: Boolean, default: false },
        orderId: { type: Number, default: null },
        title: { type: String, default: null },
    },
    data() {
        return {
            activeName: "bill",
            records: null,
            params: {
                orderId: null
            },
        };
    },
    methods: {
        handleClose(done) {
            this.$emit("update:show", false);
            done();
        },
        handleClick(tab) {
            if (tab.name == "bill") {
                this.pageBill();
            }
        },
        pageBill(current) {
            let _this = this;

            if (current) {
                _this.params.current = current;
            }

            _this.params.orderId = _this.orderId;

            _this.$http.post(
                [
                    _this.isRoot
                        ? "alibaba/bill/page"
                        : "alibaba/bill/pageByOrder",
                    _this.params,
                ],
                [
                    function (data) {
                        _this.records = data.records;
                    },
                ],
                ".alibaba-order-table"
            );
        },
    },
    mounted() {},
    watch: {
        show(val) {
            if (val) {
                this.activeName = "bill";
                this.pageBill();
            }
        },
    },
};
</script>

<style lang="scss">
#el-drawer__title {
    margin-bottom: 5px;
    padding: 20px 10px 0;
    font: bold;
}
.info-tab-outer {
    margin: 5px 10px;
}
.info-div {
    overflow: hidden;
}

.main-form {
    width: 1000px;

    .el-form-item {
        float: left;

        .el-form-item__label {
            width: 100px;
        }

        .el-form-item__content {
            width: 400px;
            float: left;
        }
    }
}
</style>